import { useCallback } from "react";
import useTrackerContext from "./useTrackerContext.js";
export default function useGTMRouteChangeEvent() {
    const { trackExternal } = useTrackerContext();
    return useCallback(() => {
        trackExternal({
            type: "gtm-route-change",
            args: [
                {
                    event: "route-change"
                }
            ]
        });
    }, [trackExternal]);
}
